import React, { useEffect, useRef, useState } from "react";
import styles from "./gallery.module.css";
import { motion, useScroll, useTransform } from "framer-motion";
import { useResolution } from "../../utils/resolutionControll";

interface Image {
  src: string;
  alt: string;
}

interface CarouselSliderProps {
  images: Image[];
}

const Gallery: React.FC<CarouselSliderProps> = ({ images }) => {
  const fourthImgRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: fourthImgRef,
    offset: ["start end", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 0.5], [1, 5]);
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "-10%"]);

  const [imageSize, setImageSize] = useState({
    width: "100%",
    height: "100%",
    scale: "1",
  });

  const width = useResolution();
  const isMobile = width < 920;

  useEffect(() => {
    return scale.on("change", (latest) => {
      console.log(latest);
      if (latest > 3.5) {
        setImageSize({
          width: "100vw",
          height: "auto",
          scale: "1",
        });
      } else {
        setImageSize({
          width: "100%",
          height: "100%",
          scale: "5",
        });
      }
    });
  }, [scale]);

  return (
    <div>
      <div className={styles.gridContainer}>
        {images.map((img, index) => {
          const isFourth = (isMobile ? index === 6 : index === 4);

          return (
            <div key={index} className={styles.gridItem}>
              <motion.img
                src={img.src}
                alt={img.alt}
                style={
                  isFourth
                    ? {
                        scale,
                        y,
                        zIndex: 1,
                        position: "relative",
                        width: imageSize.width,
                        height: imageSize.height,
                        objectFit: "contain",
                      }
                    : {}
                }
              />
            </div>
          );
        })}
      </div>
      <div
        style={{ width: "1px", height: "1px", marginTop: "100px" }}
        ref={fourthImgRef}
      ></div>
    </div>
  );
};

export default Gallery;
